import { render, staticRenderFns } from "./digit.vue?vue&type=template&id=31c57bf8&scoped=true"
import script from "./digit.vue?vue&type=script&lang=js"
export * from "./digit.vue?vue&type=script&lang=js"
import style0 from "./digit.vue?vue&type=style&index=0&id=31c57bf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c57bf8",
  null
  
)

export default component.exports